const Button = ({ text,path }) => {
  return (
    <>
      {text === "Try For Free" ||
      text === "Select Plan" ||
      text === "Get Started" ? (
        <a
          href={path}
          target="_blank"
          className={`w-full ${
            text === "Select Plan" ? "mt-5" : ""
          } sm:w-auto hover:from-[#B22222] hover:to-[#B22222]  bg-gradient-to-r from-[#B22222] to-[#FF4D4D]  font-semibold  border border-gray-400  text-white px-4 py-1.5 rounded-full`} rel="noreferrer"
        >
          {text}
        </a>
      ) : (
        <a  href={path} className="bg-[#FFFFFF] hover:bg-[#f5f5f5] font-semibold text-[#000B1C] px-3 py-1.5 w-full sm:w-auto rounded-full">
          {text}
        </a>
      )}
    </>
  );
};

export default Button;
